import React from 'react';
import NewsTemplate from '../../templates/NewsTemplate';
import { useAppSelector } from '../../../redux/app/hooks';
import {
    selectLoginState,
} from '../../../redux/slices/loginSlice';
import { selectPaymentState } from '../../../redux/slices/paymentSlice';

export type NewsPageProps = {
    children?: never;
};

const NewsPage : React.FC<NewsPageProps> = () => {
    const {
        isLogin,
        isSocialLogin,
        preferredUsername,
    } = useAppSelector(selectLoginState);

    const {
        isPaid,
    } = useAppSelector(selectPaymentState);

    // to_implement
    const profileImg = undefined;

    return (
        <NewsTemplate
          isLogin={isLogin}
          isPaid={isPaid}
          isSocialLogin={isSocialLogin}
          profileImg={profileImg}
          preferredUsername={preferredUsername}
        />
    );
};

export default NewsPage;
